import { request } from '@/api/httpClient'
import { RequestType } from '@/enums'

export async function paymentCreatePaymentRequest(contractId, JobKey) {
  return request({
    method: 'payment/CreatePaymentRequest',
    payload: {
      contractId,
      JobKey
    }
  })
}

export async function paymentGetAccount() {
  return request({
    method: 'stripe/account',
    requestType: RequestType.GET
  })
}

export async function paymentCreateAccount() {
  return request({
    method: 'stripe/createaccount'
  })
}

export async function paymentCreateAccountLink() {
  return request({
    method: 'stripe/createaccountlink'
  })
}
